import clsx from 'clsx';
import { useFormikContext } from 'formik';
import React from 'react';

import { PrimaryWhiteButton } from './Buttons';

interface CancelCsvUploadFormSubmitButtonProps {
  children: React.ReactNode;
  resetInitialValueFn?: (...args: any) => void;
  className?: string;
  onClick?: (e: any) => void;
}

const CancelCsvUploadFormSubmitButton: React.FC<
  CancelCsvUploadFormSubmitButtonProps
> = ({ children, className, onClick }) => {
  const { dirty, isValid } = useFormikContext<any>();
  const isDisabled = !(isValid && dirty);

  return isDisabled ? (
    <PrimaryWhiteButton
      onClick={onClick}
      type='button'
      className={clsx(className)}
    >
      {children}
    </PrimaryWhiteButton>
  ) : null;
};

export default CancelCsvUploadFormSubmitButton;
